module.exports = __webpack_public_path__ + "079b78df80541b863db603b5ba9e4fc0.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-110.cur
// module id = 435
// module chunks = 0